import { Lock } from "components/icons/generated";
import Icon from "ds/components/Icon";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { TofuWorkspace } from "types/generated";

const StackWorkspacesLockStatusCell = ({
  item: workspace,
  ...cellProps
}: TableSimpleCellProps<TofuWorkspace>) => {
  return (
    <TableSimpleCell {...cellProps}>{workspace.isLocked && <Icon src={Lock} />}</TableSimpleCell>
  );
};

export default StackWorkspacesLockStatusCell;
